const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class CtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 5,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3,
              spacing: 5,
            },
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
